import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Icon } from "semantic-ui-react";
import DropdownMenu from "../../../Forms/Controls/DropdownMenu";
import { useNavigate } from "react-router-dom";
import { snakeToTitleCase } from "../../../../utils";

function FeatureGroup({
  isActive,
  feature_name,
  feature_items,
  pathname,
  hasChildren,
  hasSelectMenu,
  defaultCustomProject,
  permittedCustomProjects,
  audienceVariables,
  variables,
  audiences,
}) {
  const navigate = useNavigate();

  const [menuOpen, setMenuOpen] = useState(isActive);

  return (
    <li
      className={`menu__main ${menuOpen ? "active" : "default"}`}
      tabIndex={0}
      data-testid={`nav-feature-li#${feature_name}`}
      onClick={() => {
        if (hasChildren) setMenuOpen((prev) => !prev);
      }}
    >
      <Link
        to={hasChildren ? null : feature_items.path}
        data-testid={hasChildren ? null : `nav-link#${feature_items.path}`}
      >
        <span className="menu__icon">
          <Icon name={feature_items.icon} />
        </span>
        {snakeToTitleCase(feature_name)}
        {hasChildren && (
          <span className="toggle__icon">
            <Icon name="triangle down" />
          </span>
        )}
      </Link>

      {hasSelectMenu && permittedCustomProjects?.value.length > 0 && (
        <div className="dropdown-menu-wrapper">
          <DropdownMenu
            defaultCustomProject={defaultCustomProject}
            items={permittedCustomProjects.value.map((item) => {
              return {
                value: item.key,
                text: item.label,
                key: item.key,
              };
            })}
            selectOption={(id) => {
              if (defaultCustomProject.value[0] === id)
                //   defaultCustomProject.set([]);
                return;

              const id_ = [];
              id_.push(id);
              defaultCustomProject.set(id_);

              // Redirect to reports or audiences list page if on report or audience page
              // /custom-projects/106/reports/new
              // /custom-projects/106/reports/edit/199
              // /custom-projects/104/reports/167
              // /custom-projects/104/reports/

              // /custom-projects/105/audiences/new
              // /custom-projects/104/audiences/edit/232
              // /custom-projects/104/audiences

              const regexReportURL = new RegExp(
                "^/custom-projects/\\d+/reports(/(new|edit/\\d+|\\d+))?$"
              );
              const regexAudienceURL = new RegExp(
                "^/custom-projects/\\d+/audiences(/(new|edit/\\d+|\\d+))?$"
              );

              // let url = `/custom-projects/${id}/reports`;
              let url = null;

              if (regexReportURL.test(pathname)) {
                url = `/custom-projects/${id}/reports`;
              }
              if (regexAudienceURL.test(pathname)) {
                url = `/custom-projects/${id}/audiences`;
              }
              if (url)
                setTimeout(() => {
                  navigate(url);
                }, 100);

              // Clear variables in state
              audienceVariables.set([]);
              variables.set([]);
              audiences.set([]);
            }}
          />
        </div>
      )}
      {hasChildren && (
        <ul>
          {feature_items.items.map((item, index) => (
            <li
              key={index}
              className={`menu__item ${
                pathname === item.path ? "active" : "default"
              }`}
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              <Link
                to={item.path}
                disabled={true}
                data-testid={`nav-link#${item.path}`}
              >
                {item.label}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </li>
  );
}

export default FeatureGroup;
